/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 13:48:36
 * @LastEditTime: 2023-03-01 14:20:04
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionDetail/UserPermission/index.tsx
 */
import Configuration from '@/src/components/Configuration/Configuration';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Divider, Form } from 'antd';
import { get } from 'lodash';
import React from 'react';
import CheckboxTree from '../../Components/CheckboxTree';
import SelectAll from '../../Components/SelectAll';
import css from '../style.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const UserPermission = ({ form, disabled, onValueChange }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const onCheckAllChange = (e) => {
    const storeRoles = form.getFieldValue('storeRoles');
    const salesChannelRoles = form.getFieldValue('salesChannelRoles');
    const storeRolesValue = (storeRoles || []).map((item) => ({
      ...item,
      checked: e.target.checked,
    }));
    const salesChannelRolesValue = (salesChannelRoles || []).map((item) => ({
      ...item,
      roles: item.roles.map((role) => ({
        ...role,
        checked: e.target.checked,
      })),
    }));
    form.setFieldsValue({
      storeRoles: storeRolesValue,
      salesChannelRoles: salesChannelRolesValue,
    });
    onValueChange();
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('usersAndPermissions.detail.userPermission')}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          return (
            prevValues.storeRoles !== curValues.storeRoles ||
            prevValues.salesChannelRoles !== curValues.salesChannelRoles
          );
        }}>
        {({ getFieldValue }: any) => (
          <SelectAll
            value={[
              getFieldValue('storeRoles'),
              getFieldValue('salesChannelRoles'),
            ]}
            onChange={onCheckAllChange}
            disabled={disabled}
          />
        )}
      </Form.Item>
      <Divider className={css.divider} />
      <Form.Item name='storeRoles'>
        <CheckboxTree
          disabled={disabled}
          checkAllText={getI18n('usersAndPermissions.detail.store')}
        />
      </Form.Item>
      <Form.List name='salesChannelRoles'>
        {(fields, { add, move, remove }) => (
          <div className={css.salesChannelRoles}>
            {fields.map((item, index) => {
              return (
                <Form.Item
                  key={index}
                  className={css.salesChannelRole}
                  name={[fields[index].name, 'roles']}>
                  <CheckboxTree
                    disabled={disabled}
                    checkAllText={`${get(
                      form.getFieldValue('salesChannelRoles'),
                      [index, 'salesChannel', 'name'],
                    )} | 
                   ${get(form.getFieldValue('salesChannelRoles'), [
                     index,
                     'salesChannel',
                     'channelType',
                   ])} `}
                  />
                </Form.Item>
              );
            })}
          </div>
        )}
      </Form.List>
      <Configuration
        configStart={getI18n('usersAndPermissions.detail.goto')}
        linkTo='/'
        configLink={getI18n('usersAndPermissions.detail.helpCentre')}
        configEnd={getI18n('usersAndPermissions.detail.configurationconfigEnd')}
      />
    </SectionWrapper>
  );
};

export default UserPermission;
